<template>
  <div class="con-wrap-inner">
    <el-aside width="280px">
      <el-row class="title" :gutter="20">
        <el-col :span="16">
          <div class="grid-content bg-purple">角色列表</div>
        </el-col>
        <el-col :span="2" :offset="6">
          <div
            class="grid-content bg-purple iconfont icon-add"
            v-if="hasPerm('sys:role:save')"
            @click="addRole"
            style="cursor:pointer"
          ></div>
        </el-col>
      </el-row>
      <div>
        <ul class="role-list">
          <li
            v-for="item in roleList"
            class="is-show role-list-con"
            :class="{ active: flag == item.roleId }"
            :key="item.roleId"
            @click="getUserList(item)"
          >
            <span class="roleName" :title="item.roleName">{{
              item.roleName
            }}</span>
            <span style="display:none">
              <span
                @click="editRole(item)"
                v-if="hasPerm('sys:role:update')"
                class="iconfont icon-edit"
              ></span>
              <span
                @click="romoveRole(item)"
                v-if="hasPerm('sys:role:delete')"
                class="iconfont icon-delete"
              ></span>
            </span>
          </li>
        </ul>
      </div>
    </el-aside>

    <el-container style="flex-direction:column">
      <el-row class="title" :gutter="20">
        <el-col :span="16">
          <div class="grid-content bg-purple">用户列表</div>
        </el-col>
        <el-col :span="6" :offset="2">
          <div
            class="title-edit"
            style="float:right"
            @click="editUser"
            v-if="hasPerm('sys:user:role')"
          >
            <i class="iconfont icon-edit"></i>
            编辑用户
          </div>
        </el-col>
      </el-row>
      <div style="display:block">
        <span v-for="item in UserList" :key="item.userId" class="tag">{{
          item.fullName
        }}</span>
      </div>
    </el-container>
    <!-- 角色弹框 -->
    <el-dialog
      :title="roleTitle"
      :visible.sync="roleVisible"
      class="mini-dialog"
    >
      <el-form
        :rules="roleRules"
        ref="roleForm"
        :model="roleForm"
        size="mini"
        :inline="true"
      >
        <el-form-item prop="roleName" label="角色名称">
          <el-input
            v-model="roleForm.roleName"
            placeholder="请输入角色名称"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="描述">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入描述"
            v-model="roleForm.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleVisible = false">取 消</el-button>
        <el-button type="primary" @click="roleSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 用户弹框 -->
    <el-dialog
      :title="userTitle"
      :visible.sync="userVisible"
      class="transfer-dialog"
    >
      <user-transfer
        leftTitle="已选择用户"
        rightTitle="未选择用户"
        listName="fullName"
        listId="userId"
        :leftList="UserList"
        :rightList="unUserList"
        @clickLeft="addLeft"
        @clickRight="addRight"
      ></user-transfer>
    </el-dialog>
  </div>
</template>

<script>
import UserTransfer from "../../../../components/UserTransfer.vue"
export default {
  name: "role",
  components: {
    UserTransfer,
  },
  data() {
    return {
      roleList: [],
      editTag: 0,
      roleTitle: "",
      userTitle: "",
      roleVisible: false,
      userVisible: false,
      roleId: "",
      flag: -1,
      roleRules: {
        roleName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入角色名称",
          },
        ],
      },
      roleForm: {
        roleName: "",
        remark: "",
      },
      //用户弹框
      UserList: [],
      unUserList: [],
    }
  },
  mounted() {
    this.getRoleList()
  },
  watch: {
    roleList(val) {
      if (val[0]) {
        this.$nextTick(() => {
          document.querySelector(".role-list-con").click()
        })
      }
    },
  },
  methods: {
    async getRoleList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/sys/role/list")
      if (res.code == 1) {
        _this.roleList = res.data
        _this.roleId = res.data[0].id
      } else {
        _this.$message.warning(res.msg)
      }
    },
    addRole() {
      this.editTag = "0"
      this.$resetForm(this, "roleForm")
      this.roleForm.roleName = ""
      this.roleTitle = "新增角色"
      this.roleVisible = true
    },
    editRole(item) {
      this.editTag = "1"
      this.$resetForm(this, "roleForm")
      this.roleTitle = "修改角色"
      this.roleVisible = true
      this.roleId = item.roleId
      this.roleForm.roleName = item.roleName
      this.roleForm.remark = item.remark
    },
    roleSubmit() {
      let _this = this
      let id = 0
      if (_this.editTag == "0") {
        id = ""
      } else {
        id = _this.roleId
      }
      let parm = {
        roleId: id,
        roleName: _this.roleForm.roleName,
        remark: _this.roleForm.remark,
      }
      let data = []
      _this.$refs.roleForm.validate(async (valid) => {
        if (valid) {
          if (_this.editTag == "0") {
            data = await _this.$axios.post("/api/sys/role", parm)
          } else {
            data = await _this.$axios.patch("/api/sys/role", parm)
          }
          let res = data.data
          if (res.code == 1) {
            _this.$message.success("操作成功")
            _this.getRoleList()
            _this.roleVisible = false
          } else {
            _this.$message.warning(res.msg)
          }
        }
      })
    },
    romoveRole(item) {
      let _this = this
      let roleId = item.roleId
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete(
            "/api/sys/role/" + roleId
          )
          if (res.code == 1) {
            _this.$message.success("操作成功")
            _this.getRoleList()
          } else {
            _this.$message.warning(res.msg)
          }
        })
    },
    async getUserList(data) {
      let _this = this
      _this.flag = data.roleId
      _this.roleId = data.roleId
      let parm = {
        roleId: data.roleId,
        range: 1,
      }
      let { data: res } = await _this.$axios.get("/api/sys/user/options", {
        params: parm,
      })
      if (res.code == 1) {
        _this.UserList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    editUser() {
      this.userVisible = true
      this.userTitle = "编辑用户"
      this.getUnselectUser()
    },
    async getUnselectUser() {
      let _this = this
      let parm = {
        roleId: _this.roleId,
        range: 2,
      }
      let { data: res } = await _this.$axios.get("/api/sys/user/options", {
        params: parm,
      })
      if (res.code == 1) {
        _this.unUserList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async addRight(selectForm) {
      let parm = {
        operating: 2,
        roleId: this.roleId,
        userIds: selectForm,
      }
      this.reviseUserRely(parm)
    },
    addLeft(unselectForm) {
      let parm = {
        operating: 1,
        roleId: this.roleId,
        userIds: unselectForm,
      }
      this.reviseUserRely(parm)
    },
    async reviseUserRely(parm) {
      let _this = this
      let { data: res } = await _this.$axios.patch("/api/sys/user/role", parm)
      if (res.code == 1) {
        //信息提示
        _this.$message.success("操作成功")
        //刷新部门树
        _this.getUnselectUser()
        _this.getUserList(parm)
      } else {
        _this.$message.warning(res.msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap-inner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  background-color: #f8f8f8;
}
.con-wrap-inner .el-container {
  background-color: #fff;
}
.title-edit {
  cursor: pointer;
}
.title-edit:hover {
  color: #0094ff;
}
.is-show:hover :nth-child(2) {
  display: inline-block !important;
}
.mini-dialog /deep/ .el-form-item__content {
  height: auto;
  min-height: 32px;
}
.role-list {
  position: relative;
  cursor: default;
  background: #fff;
  color: #606266;
}
.role-list .is-show {
  height: 28px;
  line-height: 28px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 0 14px;
  cursor: pointer;
}
.role-list .is-show:hover {
  background: #f5f7fa;
}
.role-list .active {
  background: #ddf0fe !important;
  color: #0094ff;
}
.roleName {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 150px;
}
.tag {
  display: inline-block;
  width: 120px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  margin: 10px;
  font-size: 14px;
  color: #333;
  border-radius: 4px;
  background-color: #ddf0fe;
}
</style>
